'use client'
import { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'

const ScrollProgressButton = () => {
  const [scrollProgress, setScrollProgress] = useState(0)
  const [isActive, setIsActive] = useState(false)

  const handleScroll = () => {
    const totalHeight = document.body.scrollHeight - window.innerHeight
    const progress = (window.scrollY / totalHeight) * 100
    setScrollProgress(progress)
    setIsActive(window.scrollY > 50)
  }

  const handleProgressClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    window.scrollTo(0, 0)

    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <button
      aria-label="scroll button"
      className={`fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-white shadow-lg transition-all duration-300 ${
        isActive ? 'opacity-100 scale-100' : 'opacity-0 scale-0'
      }`}
      onClick={handleProgressClick}
      title="Go To Top"
    >
      {/* Vòng tròn progress */}
      <svg className="absolute top-0 left-0 w-full h-full" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="45" fill="none" stroke="#e5e7eb" strokeWidth="4" />
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="#821916"
          strokeWidth="4"
          strokeLinecap="round"
          style={{
            strokeDasharray: '282.6px',
            strokeDashoffset: `${282.6 - (scrollProgress / 100) * 282.6}px`,
          }}
        />
      </svg>
      {/* Icon mũi tên FontAwesome */}
      <FontAwesomeIcon icon={faArrowUp} className="relative text-primary" size="lg" />
    </button>
  )
}

export default ScrollProgressButton
